module.exports = __webpack_public_path__ + "static/img/calzetta.ced2cc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/calzetta.jpg
// module id = 460
// module chunks = 11